// @owners { team: patient-fulfillment }
import { ActionSheetContext, Button, Description, InlineAlert, XsSpacing } from '@alto/design-system';
import React, { useCallback, useContext } from 'react';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { type BackorderOrigin } from '../constants';
import { useBackorderedAnalytics } from '../hooks/useBackorderedAnalytics';
import { BackorderedActionSheet } from './BackorderedActionSheet';

type Props = {
  readonly origin: BackorderOrigin;
  readonly prescriptionId: number;
};

export const BackorderedAlert = ({ origin, prescriptionId }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  useBackorderedAnalytics({ origin, prescriptionId, event: EVENTS.C2_BACKORDER_ALERT_VIEWED });

  const handleFaqPress = useCallback(() => {
    setActiveActionSheet(
      <BackorderedActionSheet
        origin={origin}
        prescriptionId={prescriptionId}
      />,
    );
  }, [setActiveActionSheet, origin, prescriptionId]);

  return (
    <InlineAlert type="error">
      <Description fontFamily="semibold">Out of stock with no return date</Description>
      <XsSpacing />
      <Description>
        There is currently a shortage across multiple manufacturers and suppliers. Check back later as stock
        availability is updated based on our supplier's restock dates.
      </Description>
      <XsSpacing />
      <Button
        onPress={handleFaqPress}
        label="Backorder FAQs"
        small
        width="inline"
        noPadding
        alignment="left"
        type="tertiary"
      />
    </InlineAlert>
  );
};
